import { gql } from '@apollo/client';

export const USER_LOGIN = gql`
  mutation Mutation($userDetail: LoginUserInput) {
    loginUser(userDetail: $userDetail) {
      firstname
      email
      token
    }
  }
`;

// Checks the existance of user with email id
export const GET_USER_BY_EMAIL = gql`
  query GetUserByEmail($email: String) {
    getUserByEmail(email: $email) {
      firstname
      lastname
      accounts {
        id
      }
    }
  }
`;

// Creates the new user
export const REGISTER_USER = gql`
  mutation RegisterUser($userDetail: RegisterUserInput) {
    registerUser(userDetail: $userDetail) {
      firstname
      token
    }
  }
`;

// Sends the money to other user using email
export const SEND_ETRANSFER = gql`
  mutation SendEtransfer($etransferDetail: EtransferInput) {
    sendEtransfer(etransferDetail: $etransferDetail) {
      id
      account_id
      description
      type
      createdAt
      amount
    }
  }
`;

// Gets account details with transactions
export const GET_ACCOUNT_DETAILS = gql`
  query Query($accountId: ID!) {
    getAccountDetailAndTransactions(accountId: $accountId) {
      account {
        type
        acc_number
        name
        balance
        goal_amount
      }
      transactions {
        id
        description
        type
        createdAt
        amount
      }
    }
  }
`;

// Creates new acoount based on user inputs
export const CREATE_ACC = gql`
  mutation Mutation($accountDetail: CreateAccountInput) {
    createAccount(accountDetail: $accountDetail) {
      id
      user_id
      acc_number
      type
      name
      balance
      goal_amount
    }
  }
`;

// Gets info of all accounts for homepage
export const GET_ALL_ACCOUNTS = gql`
  query Query {
    getAllAccounts {
      id
      acc_number
      type
      name
      balance
      goal_amount
      end_date
      is_freeze
    }
  }
`;

// Deposits mney to current account
export const DEPOSIT_MONEY = gql`
  mutation Mutation($transactionDetail: TransactionInput) {
    createTransaction(transactionDetail: $transactionDetail) {
      id
      account_id
      description
      type
      createdAt
      amount
    }
  }
`;